/**
 * 车队风险评估报告V2
 */
import { Card, message } from "antd"
import styles from "./index.module.scss"
import FilterForm from "./components/filterForm"
import FleetOverviewTable from "./components/fleetOverviewTable"
import WeeklySafetyScore from "./components/weeklySafetyScore"
import WeeklyVehicleRiskDetails from "./components/weeklyVehicleRiskDetails"
import LastWeekHighRiskVehicleStatus from "./components/lastWeekHighRiskVehicleStatus"
import FleetOperationStatus from "./components/fleetOperationStatus"
import EnvironmentRoadRisk from "./components/environmentRoadRisk"
import AlarmAnalysis from "./components/alarmAnalysis"
import BrakingSpeedAnalysis from "./components/brakingSpeedAnalysis"
import BrakingScenarioAnalysis from "./components/brakingScenarioAnalysis"
import DeviceBrakingStatistics from "./components/deviceBrakingStatistics"
import DriverRiskAnalysis from "./components/driverRiskAnalysis"
import { useState } from "react"
import { type iExportFleetReportV2Response, getFleetReportV2Request, exportFleetReportV2Request } from "@/service/fleetRisk"


/**
 * 车队风险评估报告V2
 */
const CarReportV2 = () => {

  const [pageData, setPageData] = useState<any>(null)
  const [isSearching, setIsSearching] = useState<boolean>(false);
  const [isExporting, setIsExporting] = useState<boolean>(false);
  const [tempFleetName, setTempFleetName] = useState<string>(''); // 临时存储车队名称

  const updatePageData = async (params: iExportFleetReportV2Response) => {
    let resData = {};
    setIsSearching(true);
    try {
      const res = await getFleetReportV2Request(params) || {};
      resData = res?.data?.data?.data || {};
    } catch (err) {
      console.error('获取车队报告V2数据失败:', err);
    } finally {
      setPageData(resData);
      setIsSearching(false);
      setTempFleetName(params.report_name || ''); // 更新临时车队名称
    }
  }

  const exportPageData = async (newData: iExportFleetReportV2Response) => {
    // let newPageData = {};
    setIsExporting(true);
    try {
      //从local里获取userID
      const userInfo = localStorage.getItem('userDetail') || '{}';
      const userId = JSON.parse(userInfo).id || '';
      console.log('导出车队报告V2参数:', newData, userId);
      const params = {
        user_id: userId,
        ...newData
      }
      const res = await exportFleetReportV2Request(params) || {};
      const url = res?.data?.data?.url || '';
      if (url) {
        window.open(url, '_blank');
      } else {
        message.error('导出失败，请稍后重试');
      }


      // console.log('导出接口返回数据:', res);
    } catch (err) {
      console.error('导出车队报告V2数据失败:', err);
    }
    finally {
      setIsExporting(false);
    }

  }



  return (
    <Card bordered={false} className={styles.card}>
      <FilterForm onSearch={updatePageData} onExport={exportPageData} isSearching={isSearching} isExporting={isExporting} />
      {
        pageData && <FleetOverviewTable
          data={pageData?.stats?.text_numbers?.basic_stats}
          fleetName={tempFleetName}
        />
      }
      {
        pageData && (
          <WeeklySafetyScore
            data={pageData?.radar}
            riskAssessment={pageData?.stats?.text_numbers?.risk_level_assessment}
            vehicleRiskTable={pageData?.stats?.tables?.vehicle_risk_table}
          />
        )
      }
      {
        pageData && (
          <WeeklyVehicleRiskDetails data={pageData?.stats?.tables?.vehicle_risk_table || []} />
        )
      }
      {
        pageData && (
          <LastWeekHighRiskVehicleStatus data={pageData?.stats?.tables?.risk_vehicle_comparison_table || []} />
        )
      }
      {
        pageData && (
          <FleetOperationStatus
            overviewData={pageData?.stats?.text_numbers?.fleet_conclusions}
            chartsData={pageData?.stats?.charts}
          />
        )
      }
      {
        pageData && (
          <EnvironmentRoadRisk
            // riskRoads={pageData?.stats?.charts?.risk_roads}
            pieChartData={pageData?.charts?.pie_chart}
            analysisDescription={pageData?.charts?.pie_chart_analysis || pageData?.stats?.text_numbers?.road_risk_analysis?.environment_road_risk_analysis}
          />
        )
      }
      {
        pageData && (
          <AlarmAnalysis
            hmwData={pageData?.charts?.hmw}
            ldwData={pageData?.charts?.ldw}
            fcwData={pageData?.charts?.fcw}
            aebData={pageData?.charts?.aeb}
            analysisData={pageData?.stats?.text_numbers?.alarm_trend_analysis}
          />
        )
      }
      {
        pageData && (
          <BrakingSpeedAnalysis
            speedDistribution={pageData?.charts?.ring_chart}
            speedDescription={pageData?.stats?.text_numbers?.device_conclusions?.设备速度描述}
          />
        )
      }
      {
        pageData && (
          <BrakingScenarioAnalysis
            data={pageData?.stats?.tables?.reason_ranking_table || []}
            analysisDescription={pageData?.stats?.text_numbers?.device_conclusions?.设备制动原因描述}
          />
        )
      }
      {
        pageData && (
          <DeviceBrakingStatistics
            tableData={pageData?.stats?.tables?.brake_count_table || []}
            chartData={pageData?.stats?.charts?.aeb_brake_chart || []}
            analysisData={pageData?.stats?.text_numbers?.device_conclusions?.设备制动统计分析}
          />
        )
      }
      {
        pageData && (
          <DriverRiskAnalysis
            cabRiskData={pageData?.stats?.charts?.cab_risk}
            dmsDetailedData={pageData?.stats?.charts?.dms_detailed}
            cabRiskTable={pageData?.stats?.tables?.cab_risk_table}
            analysisDescription={pageData?.stats?.text_numbers?.risk_level_assessment?.驾驶行为评估}
          />
        )
      }
    </Card>
  )
}



export default CarReportV2
